import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';

import { complexQueryParams } from 'rise-ui/decorators/complex-query-params.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

import strings from 'rise-ui/config/strings.js';
import { breadcrumb } from 'rise-ui/services/breadcrumb.js';
import { timeSeriesSearchRouteQueryParams } from 'rise-ui/services/time-series/search.js';

@complexQueryParams
@scrollRoot
export default class TimeSeriesSearchRoute extends Route {
  @service ssr;
  @service router;
  @service routing;
  @service scrollRoot;
  @service('time-series/search') timeSeriesSearch;

  queryParams = timeSeriesSearchRouteQueryParams;

  setHeadTags(model) {
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: 'Search and select locations to query time series data from the '
            + 'Bureau of Reclamation on water, reservoir operations, water quality, '
            + 'hydropower, endangered and invasive species, and more at sub-hourly '
            + 'to annual intervals.  Filter locations by theme, project/data collection '
            + 'effort, parameter group, parameter timestep, location type, region, '
            + 'and state.',
        },
      },
    ];
  }

  @breadcrumb crumb = strings['time-series-search-route'];

  model() {
    this.timeSeriesSearch.clearEdit().setParams(...arguments);
  }
}
